import React, { FC } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { IconProps } from './common/iconProps';

export const SignOutIcon:
FC<IconProps> = ({ className }) => <FaSignOutAlt className={className} />;
